import React from "react";
import { useStytchMemberSession } from "@stytch/react/b2b";
import Login from "./Login";

interface AuthWrapperProps {
    children: React.ReactNode;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
    const { session, isInitialized } = useStytchMemberSession();

    // If the SDK hasn't initialized yet, or we're in the middle of an exchange
    if (!isInitialized) {
        return (
            <div className="flex h-screen w-full items-center justify-center bg-gray-900 text-gray-100">
                <div className="flex flex-col items-center gap-4">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
                    <p>Connecting to Authentication Service...</p>
                </div>
            </div>
        );
    }

    // If no session, show the login screen
    if (!session) {
        return <Login />;
    }

    // If session exists, show the app
    return <>{children}</>;
};

export default AuthWrapper;
